import React from 'react';
import { Shield } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      {/* Hero Section */}
      <section className="relative py-16 bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="flex justify-center mb-4">
              <Shield className="w-16 h-16" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Privacy Policy
            </h1>
            <p className="text-xl text-blue-100">
              Nikita's Reizen op Maat
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12">

            {/* Section 1 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">1. Wie zijn wij</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Nikita's Reizen op Maat, gevestigd in Nederland, is verantwoordelijk voor de verwerking van persoonsgegevens zoals weergegeven in deze privacyverklaring.
              </p>
              <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
                <p className="font-semibold text-blue-900 mb-2">Bedrijfsgegevens:</p>
                <div className="space-y-1 text-gray-700">
                  <p className="font-medium">Nikita's Reizen op Maat</p>
                  <p>📧 Nikitasopmaatreizen@outlook.com</p>
                  <p>📱 06 243 597 64</p>
                  <p>KvK: 42050105</p>
                </div>
              </div>
            </div>

            {/* Section 2 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">2. Persoonsgegevens die wij verwerken</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Nikita's Reizen op Maat verwerkt jouw persoonsgegevens doordat je gebruik maakt van onze diensten en/of omdat je deze zelf aan ons verstrekt.
              </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                Wij kunnen onder andere de volgende gegevens verwerken:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                <li>Voor- en achternaam</li>
                <li>Adresgegevens</li>
                <li>Telefoonnummer</li>
                <li>E-mailadres</li>
                <li>Geboortedatum</li>
                <li>Paspoortgegevens (indien noodzakelijk voor boekingen)</li>
                <li>Reisvoorkeuren</li>
                <li>Betalingsgegevens</li>
              </ul>
            </div>

            {/* Section 3 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">3. Bijzondere en/of gevoelige gegevens</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Voor het uitvoeren van reizen kan het noodzakelijk zijn om gevoelige gegevens te verwerken, zoals:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed mb-3">
                <li>Paspoortgegevens</li>
                <li>Medische informatie (alleen indien relevant voor de reis, zoals allergieën)</li>
              </ul>
              <p className="text-gray-700 leading-relaxed">
                Deze gegevens worden uitsluitend verwerkt indien noodzakelijk en met jouw toestemming.
              </p>
            </div>

            {/* Section 4 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">4. Doeleinden van gegevensverwerking</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Wij verwerken jouw gegevens voor de volgende doeleinden:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                <li>Het samenstellen en boeken van reizen</li>
                <li>Het communiceren over jouw reis</li>
                <li>Het doorgeven van gegevens aan leveranciers (zoals hotels en luchtvaartmaatschappijen)</li>
                <li>Het afhandelen van betalingen</li>
                <li>Het voldoen aan wettelijke verplichtingen</li>
              </ul>
            </div>

            {/* Section 5 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">5. Rechtsgrond voor verwerking</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Wij verwerken jouw gegevens op basis van:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                <li>Toestemming van de klant</li>
                <li>Uitvoering van een overeenkomst</li>
                <li>Wettelijke verplichtingen</li>
              </ul>
            </div>

            {/* Section 6 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">6. Delen van persoonsgegevens met derden</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Nikita's Reizen op Maat deelt jouw gegevens uitsluitend met derden indien dit noodzakelijk is voor de uitvoering van de overeenkomst.
              </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                Dit betreft onder andere:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed mb-3">
                <li>Luchtvaartmaatschappijen</li>
                <li>Hotels en accommodaties</li>
                <li>Lokale partners (DMC's, transfers, excursies)</li>
                <li>Boekingsplatformen</li>
              </ul>
              <p className="text-gray-700 leading-relaxed font-semibold">
                Wij verkopen jouw gegevens nooit aan derden.
              </p>
            </div>

            {/* Section 7 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">7. Doorgifte buiten de EU</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                In sommige gevallen kunnen persoonsgegevens worden doorgegeven aan partijen buiten de Europese Economische Ruimte.
              </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                Wij zorgen ervoor dat dit gebeurt volgens de geldende privacywetgeving, bijvoorbeeld via:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                <li>Samenwerking met partijen die gebruikmaken van standaard contractbepalingen</li>
                <li>Betrouwbare en erkende leveranciers</li>
              </ul>
            </div>

            {/* Section 8 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">8. Bewaartermijn</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Wij bewaren jouw persoonsgegevens niet langer dan noodzakelijk is voor het doel waarvoor deze zijn verzameld.
              </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                In het algemeen hanteren wij:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                <li>Administratieve gegevens: tot 7 jaar (wettelijke verplichting)</li>
                <li>Reisgegevens: zolang nodig voor uitvoering en nazorg</li>
              </ul>
            </div>

            {/* Section 9 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">9. Beveiliging van persoonsgegevens</h2>
              <p className="text-gray-700 leading-relaxed">
                Nikita's Reizen op Maat neemt passende maatregelen om misbruik, verlies, onbevoegde toegang en andere ongewenste handelingen met persoonsgegevens tegen te gaan.
              </p>
            </div>

            {/* Section 10 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">10. Jouw rechten</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Je hebt het recht om:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed mb-4">
                <li>Jouw gegevens in te zien</li>
                <li>Jouw gegevens te laten corrigeren</li>
                <li>Jouw gegevens te laten verwijderen</li>
                <li>Bezwaar te maken tegen verwerking</li>
                <li>Gegevensoverdracht aan te vragen</li>
              </ul>
              <p className="text-gray-700 leading-relaxed">
                Je kunt een verzoek indienen via:<br />
                📧 <a href="mailto:Nikitasopmaatreizen@outlook.com" className="text-blue-700 hover:text-blue-900 underline">Nikitasopmaatreizen@outlook.com</a>
              </p>
            </div>

            {/* Section 11 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">11. Cookies</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Onze website kan gebruik maken van cookies om de gebruikerservaring te verbeteren.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Je kunt cookies uitschakelen via je browserinstellingen.
              </p>
            </div>

            {/* Section 12 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">12. Klachten</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Heb je een klacht over de verwerking van jouw persoonsgegevens? Dan kun je contact opnemen via bovenstaande gegevens.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Je hebt ook het recht om een klacht in te dienen bij de Autoriteit Persoonsgegevens.
              </p>
            </div>

            {/* Section 13 */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-blue-900 mb-4">13. Wijzigingen</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Nikita's Reizen op Maat behoudt zich het recht voor om deze privacyverklaring te wijzigen.
              </p>
              <p className="text-gray-700 leading-relaxed">
                De meest actuele versie is altijd beschikbaar op de website.
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
